export class CarousalConstants {
}
CarousalConstants.THUMBNAIL_ICON_HEIGHT = '66px';
CarousalConstants.THUMBNAIL_ICON_WIDTH = '66px';
CarousalConstants.THUMBNAIL_WIDTH = 120;
CarousalConstants.DEFAULT_SCALE = 1;
CarousalConstants.CLASS_NAV_RIGHT_ARROW = 'mi-file-viewer-attachment-right-arrow';
CarousalConstants.CLASS_NAV_RIGHT_ARROW_BOLD = 'mi-icon-pagination-right-bold';
CarousalConstants.CLASS_NAV_LEFT_ARROW = 'mi-file-viewer-attachment-left-arrow';
CarousalConstants.CLASS_NAV_LEFT_ARROW_BOLD = 'mi-icon-pagination-left-bold';
CarousalConstants.CLASS_LEFT_ARROW = 'left-arrow';
CarousalConstants.CLASS_RIGHT_ARROW = 'right-arrow';
CarousalConstants.CLASS_THUMBNAIL_CONTAINER = 'thumnail-container';
CarousalConstants.IMAGE_WIDTH_AUTO = 'auto';
//# sourceMappingURL=CarousalConstants.js.map